import axios from "axios";
import Footer from "./Footer";
import NavBar from "./NavBar";
import { useEffect, useState } from "react";
import { ChevronLeft, User } from "lucide-react";
import Loading from "./Loading";
import { useNavigate } from "react-router-dom";
import { jwtDecode } from "jwt-decode";

function MinhaConta() {
  const [detalhe, setDetalhe] = useState({});
  const [dataFormatada, setDataFormatada] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  function formatarData(dataISO) {
    const data = new Date(dataISO);
    const dia = String(data.getDate()).padStart(2, "0"); // Adiciona zero à esquerda se necessário
    const mes = String(data.getMonth() + 1).padStart(2, "0"); // Mês é baseado em zero, então +1
    const ano = data.getFullYear();
    return `${dia}-${mes}-${ano}`;
  }

  async function mostrar() {
    try {
      setLoading(true);
      const token = JSON.parse(localStorage.getItem("token"));
      const dadosDoLocalStorage = jwtDecode(token)
      if(dadosDoLocalStorage){
        const dados = await axios.get(
          `https://api-eyazs-production-8f74.up.railway.app/detalheusuario/${dadosDoLocalStorage.idUsuario}`,
          {
            headers: {
              'Authorization': `Bearer ${token}`,  // Substitua pelo seu token de autenticação, se necessário
              'Content-Type': 'application/json'  // Define o tipo de conteúdo como JSON
            }
          }
        );
        if (dados.data) {
          setDetalhe(dados.data.detalhe);
          setDataFormatada(formatarData(dados.data.detalhe.dataSubscricao));
          console.log(detalhe)
        } else {
          console.log("nao ha dados!");
          console.log("nao ha dados!");
        }
      }
    } catch (erro) {
      console.log(erro);
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    mostrar();
  }, []);

  return (
    <div className="flex flex-col min-h-screen">
      <div className="bg-blue-500 text-gray-200 z-10">
        <NavBar />
      </div>
      {loading ? (
        <div className="z-0">
          <Loading />
        </div>
      ) : (
        <div className="flex-grow flex flex-col items-center justify-center my-8 mx-4 z-0">
          <button
            className="group absolute flex md:flex left-4 bottom-[78%] md:bottom-[82%] mt-2"
            onClick={() => {
              navigate(-1);
            }}
          >
            <div className="flex md:flex lg:hidden">
              <div>
                <ChevronLeft className="group-hover:font-semibold" />
              </div>
              <div>
                <span className="text-sm group-hover:font-semibold">
                  Voltar
                </span>
              </div>
            </div>
          </button>
          <div className="w-full max-w-3xl shadow-md border-t-2 mt-3 rounded-md bg-white p-6 font-questrial">
            <div className="flex flex-col items-center gap-6">
              <div className="border-none shadow-md aspect-square p-4 rounded-[50%] bg-zinc-50">
                <User className="text-gray-500" size={70} />
              </div>
              <div className="w-full border-t-2 shadow-md rounded-md flex flex-col gap-4 p-4">
                <div className="flex flex-col gap-2">
                  <div className="flex flex-wrap items-center">
                    <span className="font-semibold">Nome:</span>
                    <span className="ml-2">{detalhe?.nome || "dados indisponiveis"}</span>
                  </div>
                  <div className="flex flex-wrap items-center">
                    <span className="font-semibold">Endereço:</span>
                    <span className="ml-2">{detalhe?.endereco || "dados indisponiveis"}</span>
                  </div>
                  <div className="flex flex-wrap items-center">
                    <span className="font-semibold">Nuit:</span>
                    <span className="ml-2">{detalhe?.nuit || "dados indisponiveis"}</span>
                  </div>
                  <div className="flex flex-wrap items-center">
                    <span className="font-semibold">Contacto:</span>
                    <span className="ml-2">{detalhe?.contacto || "dados indisponiveis"}</span>
                  </div>
                  <div className="flex flex-wrap items-center">
                    <span className="font-semibold">Data da Subscrição:</span>
                    <span className="ml-2">{dataFormatada || "dados indisponiveis"}</span>
                  </div>
                  <div className="flex flex-wrap items-center">
                    <span className="font-semibold">
                      Colaborador Associado:
                    </span>
                    <span className="ml-2">{detalhe?.colaboradorAssociado || "dados indisponiveis" }</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      <div className="bg-blue-500 text-gray-200">
        <Footer />
      </div>
    </div>
  );
}

export default MinhaConta;
